import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { DynamicLegend } from "..";
import ForceGraph from "./forceGraph";
import ForceGraphDetail from "./forceGraphDetail";
import { FactorOuterWrapper, LegendWrapper } from "./style";

export default function D3ForceDirectedTreeV2({
  id = "container",
  data = { nodes: [], links: [], linksDetails: [] },
  onLoadClickedIndex = null,
  onChange,
  color = {},
  graphLegends = [],
  settings = {},
  isEditable = false,
  onCircleClicked,
}) {
  const [itemClickedObject, setItemClickedObject] = useState();
  const [filteredData, setFilteredData] = useState([]);
  // const [counter, setCounter] = useState('list');
  
  useEffect(() => {
    // Distinct by source
    const distinctLinksDetails = Array.from(
      new Map(data.linksDetails.map((d) => [d.source, d])).values()
    );

    // Filter black nodes
    const blackSources = new Set(
      distinctLinksDetails
        .filter((ld) => {
          const category = ld.category?.replaceAll(" ", "") || "";
          const clr = color[category] || "#000";
          return clr.toLowerCase() === "#000" || clr.toLowerCase() === "black";
        })
        .map((ld) => ld.source)
    );

    const getMyCategory = (source) => {
      for(let i=0; i<data.linksDetails.length; i++){
        if(data.linksDetails[i].source === source) return data.linksDetails[i].category.replaceAll(' ','')
      }
    }
    const filteredLinksDetails = distinctLinksDetails.filter((ld) => !blackSources.has(ld.source)).map(d => {
      const currentObject = { id: 0, value:d.value, title: d.source, category: d.category.replaceAll(' ',''), size: d.size, sourceArray: d.sourceArray, insights: d?.insights || '' }
      const array = d.rest.FactorLinkages.FactorLinkage.map((f,i) => ({
        id: i+1, value:f.LinkageWeight, value2:f.LinkedFactorWeight, title: f.LinkedFactor, category: getMyCategory(f.LinkedFactor), size: d.size, insights: f.Insights
      }))


      const details = [currentObject, ...array]
      return {
        category: d.category,
        clicked: d.clicked,
        clickedIndex: d.clickedIndex,
        insightsElementId: d.insightsElementId,
        size: d.size,
        source: d.source,
        sourceArray: d.sourceArray,
        value: d.value,
        rest: d.rest,
        details: details
      }
    });

    if(filteredData.length === 0) setFilteredData(filteredLinksDetails)

  }, [data]);


  const getHeight = () => {
    const winHt = window.innerHeight - 240
    return Math.max(winHt, 550)
  }
  const graphSettings = {
    circleScaleRatio: 0.82,  // adjust this to change circle sizes
    width: null,            // you can override width if needed
    height: getHeight(),
    chargeStrength: -150,
    collisionPadding: 10,
    // nodeMargin: 30, // working
    nodeMargin: 100,
    border: 8,
    simulationTicks: 500,
    centerY: getHeight()/2,
    font: '14px poppins',
  };

  const circleClickedFunc = (d) => {
    if(d?.source === itemClickedObject?.source) {
      onCircleClicked(null)
      // setCounter('none')
      setItemClickedObject(null)
      // setTimeout(() => {
        // setItemClickedObject(null)
        // setCounter('list')
      // }, 1000)
    } else {
      let obj = d;
      
      if(itemClickedObject !== null && itemClickedObject !== undefined && d?.source !== itemClickedObject?.source) {
        const getData = data.linksDetails.find(ld => ld.source === d?.source)
        const convertSize = (size) => {
          return (size / 2) * graphSettings.circleScaleRatio
        }
        const getDetails = () => {
          const currentObject = { id: 0, value:getData.value, title: getData.source, category: getData.category.replaceAll(' ',''), size: convertSize(getData.size), sourceArray: getData.sourceArray, insights: getData?.insights || '' }
          const array = getData.rest.FactorLinkages.FactorLinkage.map((f,i) => ({
            id: i+1, value:f.LinkageWeight, value2:f.LinkedFactorWeight, title: f.LinkedFactor, category: data.linksDetails.find(l => l.source === f.LinkedFactor).category, size: convertSize(getData.size), insights: f.Insights
          }))
          return [currentObject, ...array]
        }
        const getColor = () => {
          const category = getData.category?.replaceAll(" ", "") || "";
          const clr = color[category] || "#000";
          return clr.toLowerCase() === "#000" || clr.toLowerCase() === "black" ? "#ccc" : clr;
        }

        obj = {
          category: getData.category,
          clicked: false,
          clickedIndex: null,
          insightsElementId: getData.insightsElementId,
          size: convertSize(getData.size),
          source: getData.source,
          sourceArray: getData.sourceArray,
          value: getData.value,
          rest: getData.rest,

          details: getDetails(),
          id: getData.source.replaceAll(" ", ""),
          color: getColor(),
          index: getData.id,
        }
      }

      setItemClickedObject(obj)
      const clickInd = obj.index;
      const menuData = data.linksDetails
        .map((ld) => {
          if (
            (ld.target === data.linksDetails[clickInd]?.id ||
              ld.id === data.linksDetails[clickInd]?.target) &&
            ld.targetInsights
          ) {
            return ld;
          }
          return false;
        })
        .filter((f) => f !== false)
        .filter((f) => f.targetStr === data.linksDetails[clickInd].source);

      onCircleClicked(menuData)
      // setCounter('detail')
    }
  }

  return (
    <FactorOuterWrapper className="factorWrapper">
      <Box className="factorGraphList">
        {!itemClickedObject && filteredData?.length > 0 && data.legend && <ForceGraph settings={graphSettings} jsonData={filteredData} categoryColors={data.legend} onClicked={d => circleClickedFunc(d)} />}
        {itemClickedObject && <ForceGraphDetail settings={graphSettings} jsonData={data.linksDetails} itemClickedObject={itemClickedObject} categoryColors={data.legend} onClicked={(d) => circleClickedFunc(d)} isEditable={isEditable} onChange={(d) => onChange(d)}/>}
        <LegendWrapper className="dynamicLegend">
          <DynamicLegend legends={graphLegends} />
        </LegendWrapper>
        <LegendWrapper>
          <p>Percentages indicate overlap between insight spaces.</p>
          <p>Circle size shows category engagement (relative importance).</p>
        </LegendWrapper>
      </Box>
    </FactorOuterWrapper>
  );
}
